import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiMutationKeys, AiQueryKeys } from "#lib/AiQueryKeys.ts";
import type { UpdateSmartReportCommand } from "#types/types.ts";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateSmartReportMutation = () => {
    const { updateSmartReport } = useAiApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: AiMutationKeys.UpdateSmartReport(),
        mutationFn: async (payload: UpdateSmartReportCommand) => {
            await updateSmartReport(payload);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: AiQueryKeys.GetSmartReport() });
        }
    });
};
